export const extractErrorMessage = (error, fallbackMessage) => {
  if (!error) return fallbackMessage;

  if (error instanceof Error && typeof error.message === "string") {
    return error.message;
  }

  if (error.name === "ExceptionApi" && typeof error.message === "string") {
    return error.message;
  } else if (
    error.name === "ExceptionApi" &&
    typeof error.message === "object" &&
    error.message.message
  ) {
    return error.message.message;
  }

  return fallbackMessage;
};
